import {
  MarketingMessageType,
  MessageDirection,
} from "@redotech/redo-marketing-common/message/marketing-message-definition";
import { MarketingChannel } from "@redotech/redo-model/marketing";
import { ClassifierAction } from "@redotech/redo-model/recover-config";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const devMessageSchema = z.object({
  direction: createEnum(MessageDirection),
  content: z.string(),
  channel: z.literal(MarketingChannel.SMS),
});

export const devRunClassifier = {
  name: "devRunClassifier" as const,
  input: z.object({
    recoverConfigId: z.string(),
    marketingMessageType: createEnum(MarketingMessageType),
    /** For REPLY: the customer's message text */
    lastCustomerMessage: z.string().optional(),
    triggerKey: z.string().optional(),
    customerContext: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    action: createEnum(ClassifierAction).optional(),
    scenarioIndex: z.number().optional(),
    scenarioLabel: z.string().optional(),
    generatedContent: z.string().optional(),
    errorMessage: z.string().optional(),
    /** Current conversation messages from DB */
    messages: z.array(devMessageSchema).optional(),
  }),
};
